import { APP_URLS } from 'constants/urls';
import { DEFAULT_LIST_PARAMS } from '@lib/enums/urls';
import { TFunction } from 'i18next';

type Args = {
  id: string;
  isUsersManagementLocked: boolean;
  siteAreasCount?: number;
  t: TFunction<'translation', undefined>;
  usersCount?: number;
};

export default function getTabs({
  id,
  isUsersManagementLocked,
  siteAreasCount = 0,
  t,
  usersCount = 0,
}: Args) {
  const tabs = [
    {
      label: t('about'),
      value: APP_URLS.dashboard.sites.view.getDynamicPath({
        pathParts: {
          id: `${id}`,
        },
      }),
    },
    {
      label: t('areas'),
      value: APP_URLS.dashboard.sites.areas.getDynamicPath({
        pathParts: {
          id: `${id}`,
        },
        params: DEFAULT_LIST_PARAMS,
      }),
      counter: siteAreasCount,
    },
  ];
  if (!isUsersManagementLocked) {
    tabs.push({
      label: t('team'),
      value: APP_URLS.dashboard.sites.users.getDynamicPath({
        pathParts: {
          id: `${id}`,
        },
        params: DEFAULT_LIST_PARAMS,
      }),
      counter: usersCount,
    });
  }
  return tabs;
}
